import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Files } from '../../services/journey.service';
import { useGetMyPersonalFilesMutation } from '../../services/me.service';
import { updateFiles } from '../../features/journey';
import { fileUploadModalOpen } from '../../features/fileUpload';
import { customEventTracking } from '../../lib/gtm';
import { RootState } from '../../store';
import MyFilesV2ViewModel, { resetMyFilesCache } from '../MyFilesV2/viewModel';
import ExamsV2Model from './model';

export default function ExamsV2ViewModel() {
  const dispatch = useDispatch();
  const { sendExams } = useSelector((state: RootState) => state.schedule);

  const { isLoading: initialLoading, files: cachedFiles } = MyFilesV2ViewModel();
  const [getPersonalFiles, { isLoading: reloading }] = useGetMyPersonalFilesMutation();
  const [freshFiles, setFreshFiles] = useState<Files | null>(null);

  const files = freshFiles ?? cachedFiles;

  const loadFiles = () => {
    getPersonalFiles({})
      .unwrap()
      .then((res: Files) => {
        dispatch(updateFiles(res));
        resetMyFilesCache();
        setFreshFiles(res);
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (sendExams) loadFiles();
  }, [sendExams]);

  const isLoading = initialLoading || reloading;
  const exams = files?.exams ?? [];
  const firstThree = useMemo(() => ExamsV2Model.getFirstThree(exams), [exams]);
  const hasExams = ExamsV2Model.hasExams(exams);

  const openUploadModal = () => {
    dispatch(
      fileUploadModalOpen({
        title: 'Enviar exames',
        successMessage:
          'Seus exames foram enviados com sucesso e já estão disponíveis para serem visualizados na aba Ver exames.'
      })
    );
    customEventTracking.send({ event: 'enviar_exames_mc' });
  };

  return { isLoading, files, firstThree, hasExams, openUploadModal };
}
